// extracted by mini-css-extract-plugin
export default {"imageTop":"HeaderTop_imageTop__ouR0x"};